<template>
  <div class="marqueeitem-wrapper">
    <div class="marqueeitem-content">
      <marquee-text class="marqueeitem" :duration="300" :paused="isStop" :repeat="1" :key="refreshNum">
        <ul class="marquee-list">
          <li v-for="item in marquees[language]" @click="isStop =! isStop">{{ item }}</li>
        </ul>
      </marquee-text>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { getMarqueesList } from '@/service/api/marquees'

export default {
  name: 'MarqueeComponent',
  data() {
    return {
      isStop: false,
      marquees: {},
      refreshNum: 0
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin
    }),
    ...mapGetters({
      language: 'app/getLanguage'
    })
  },
  watch: {
    language: {
      handler: function(val) {
        this.refreshNum = Math.random() // 語系有變更就重新渲染輪播
      },
      deep: true
    }
  },
  mounted() {
    this.getMarquees()
  },
  methods: {
    /**
     * 取得跑馬燈列表
     * @returns {Promise<void>}
     */
    async getMarquees() {
      const res = await getMarqueesList()
      if (res.code === 200 && res.result.result.code === 1) {
        // console.log('res', res.result.rowsMap)
        let langKeys = [] // 語系
        let info = [] // 清單
        res.result.rowsMap.forEach((item) => {
          // console.log(item[0], item[1].messageList)
          langKeys.push(item[0]) // 建語系列表
          info.push(item[1].messageList) // 建內容
        })
        // console.log('langKeys', langKeys)
        // console.log('info', info)
        for (let i = 0; i < langKeys.length; i++) {
          this.marquees[langKeys[i]] = info[i]
        }
      } else {
        this.$message({
          message: `${res.result.result.msg}` + ` (${res.result.result.code})`,
          type: 'error'
        })
      }
      this.refreshNum = Math.random()
      console.log('this.marquees', this.marquees)
    }
  }
}
</script>

<style lang="scss" scoped>
ul.marquee-list {
  margin: 0px;
  padding: 0px;
  list-style-type: none;

  li {
    width: auto;
    cursor: pointer;
    display: inline-block;
    margin: 0px 5px;
    box-sizing: border-box;
    white-space: nowrap;
  }
}
</style>
